import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showProfiles, setShowProfiles] = useState(false);

  const { login, loading, error } = useAuth();

  // Profils de test disponibles
  const testProfiles = [
    // === DIRECTION ===
    {
      name: 'Jean Martin',
      email: 'j.martin@usine.com',
      password: 'Dir123!',
      role: 'Directeur',
      department: 'Direction',
      icon: '👑',
      description: 'Direction générale - Vision stratégique'
    },
    {
      name: 'Marie Durand',
      email: 'm.durand@usine.com',
      password: 'Chef123!',
      role: 'Chef Département',
      department: 'Qualité',
      icon: '👩‍💼',
      description: 'Chef département Qualité'
    },
    
    // === CHEFS D'ÉQUIPE ===
    {
      name: 'Pierre Leroy',
      email: 'p.leroy@usine.com',
      password: 'Chef123!',
      role: 'Chef Équipe',
      department: 'Production',
      icon: '⚙️',
      description: 'Chef équipe Production - Ligne A'
    },
    {
      name: 'Sophie Moreau',
      email: 's.moreau@usine.com',
      password: 'Chef123!',
      role: 'Chef Équipe',
      department: 'Maintenance',
      icon: '🔧',
      description: 'Chef équipe Maintenance'
    },
    {
      name: 'David Roux',
      email: 'd.roux@usine.com',
      password: 'Chef123!',
      role: 'Chef Équipe',
      department: 'Sécurité',
      icon: '🛡️',
      description: 'Chef équipe Sécurité'
    },
    
    // === OPÉRATEURS & TECHNICIENS ===
    {
      name: 'Luc Bernard',
      email: 'l.bernard@usine.com',
      password: 'Op123!',
      role: 'Opérateur',
      department: 'Production',
      icon: '👷‍♂️',
      description: 'Opérateur Ligne A - Équipe Matin'
    },
    {
      name: 'Anne Petit',
      email: 'a.petit@usine.com',
      password: 'Op123!',
      role: 'Opératrice',
      department: 'Production',
      icon: '👷‍♀️',
      description: 'Opératrice Ligne A - Équipe Matin'
    },
    {
      name: 'Marc Robert',
      email: 'm.robert@usine.com',
      password: 'Tech123!',
      role: 'Technicien',
      department: 'Maintenance',
      icon: '🔩',
      description: 'Technicien Maintenance Mécanique'
    },
    {
      name: 'Claire Michel',
      email: 'c.michel@usine.com',
      password: 'Ctrl123!',
      role: 'Contrôleuse',
      department: 'Qualité',
      icon: '🔍',
      description: 'Contrôleuse Qualité Produits'
    },
    {
      name: 'Luis Garcia',
      email: 'l.garcia@usine.com',
      password: 'Sec123!',
      role: 'Agent Sécurité',
      department: 'Sécurité',
      icon: '🚨',
      description: 'Agent Sécurité Périmètre'
    },

    // === ANCIENS PROFILS (6W2H) ===
    {
      name: 'Super Admin',
      email: 'admin@6w2h.local',
      password: 'Admin123!',
      role: 'Manager',
      department: 'Administration',
      icon: '🏛️',
      description: 'Accès complet - Administration système'
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    try {
      await login(formData.email, formData.password);
      // La redirection sera gérée par le composant parent
    } catch (error) {
      // L'erreur est déjà gérée par le contexte
      console.error('Erreur de connexion:', error.message);
    }
  };

  const handleProfileSelect = (profile) => {
    setFormData({
      email: profile.email,
      password: profile.password
    });
    setShowProfiles(false);
  };

  const handleQuickLogin = async (profile) => {
    try {
      await login(profile.email, profile.password);
    } catch (error) {
      console.error('Erreur de connexion rapide:', error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-card">
          <div className="login-header">
            <h1>Application 6W2H</h1>
            <h2>Ligne B3</h2>
            <p>Analyse et résolution des problèmes industriels</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="votre.email@entreprise.com"
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? '👁️' : '🙈'}
                </button>
              </div>
            </div>

            <div className="form-options">
              <label className="checkbox-container">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  disabled={loading}
                />
                <span className="checkmark"></span>
                Se souvenir de moi
              </label>
            </div>

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Connexion...
                </>
              ) : (
                'Se connecter'
              )}
            </button>

            <div className="profiles-section">
              <hr />
              <div className="profiles-header">
                <p>🧪 Profils de test :</p>
                <button
                  type="button"
                  className="toggle-profiles-button"
                  onClick={() => setShowProfiles(!showProfiles)}
                  disabled={loading}
                >
                  {showProfiles ? 'Masquer' : 'Afficher'} les profils
                </button>
              </div>
              
              {showProfiles && (
                <div className="profiles-grid">
                  {testProfiles.map((profile, index) => (
                    <div 
                      key={index} 
                      className={`profile-card ${profile.department.toLowerCase()}`}
                    >
                      <div className="profile-header">
                        <span className="profile-icon">{profile.icon}</span>
                        <div className="profile-info">
                          <h4>{profile.name}</h4>
                          <span className="profile-role">{profile.role}</span>
                          <span className="profile-department">{profile.department}</span>
                        </div>
                      </div>
                      <p className="profile-description">{profile.description}</p>
                      <div className="profile-credentials">
                        <small className="profile-email">{profile.email}</small>
                        <small className="profile-password">Mot de passe: {profile.password}</small>
                      </div>
                      <div className="profile-actions">
                        <button
                          type="button"
                          className="profile-fill-button"
                          onClick={() => handleProfileSelect(profile)}
                          disabled={loading}
                          title="Remplir le formulaire"
                        >
                          📝 Remplir
                        </button>
                        <button
                          type="button"
                          className="profile-login-button"
                          onClick={() => handleQuickLogin(profile)}
                          disabled={loading}
                          title="Connexion directe"
                        >
                          🚀 Connexion
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              <div className="profiles-info">
                <small>🏭 <strong>Profils industriels disponibles</strong> - Mots de passe spécifiques par rôle</small>
                <div className="password-legend">
                  <span><code>Dir123!</code> Direction</span>
                  <span><code>Chef123!</code> Chefs</span>
                  <span><code>Op123!/Tech123!/Ctrl123!/Sec123!</code> Opérateurs</span>
                </div>
              </div>
            </div>
          </form>

          <div className="login-footer">
            <div className="version-info">
              <span>Version 2.0.0</span>
              <span>•</span>
              <span>Support: IT Department</span>
            </div>
            
            <div className="security-info">
              <small>
                🔒 Connexion sécurisée SSL • 
                Session expire après 24h d'inactivité
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;


